<div class="content-container">
	<div class="content-container-header">
		@if ((!isTransferringDevices || !showLoading) && !showFailure) {
			<h3>
				<b i18n="@@addDeviceConfirmation-confirmation2">Confirmation</b>
			</h3>
		}
		@if (isTransferringDevices && showLoading) {
			<h3><b i18n="@@addDeviceConfirmation-loading2">Loading</b></h3>
		}
		@if (showFailure) {
			<h3><b i18n="@@addDeviceConfirmation-failure2">Failure</b></h3>
		}
		<mat-divider></mat-divider>

		@if (!showFailure) {
			<div>
				<!-- Confirmation for importing devices -->
				<div class="content-container-body">
					@if (!isTransferringDevices) {
						<div>
							<p>
								<ng-container i18n="@@addDeviceConfirmation-text1a"> Your request to add </ng-container>
								{{ deviceCount }}
								<ng-container i18n="@@addDeviceConfirmation-text1b"> device(s) is being processed. </ng-container>
							</p>
							<p i18n="@@addDeviceConfirmation-text2">
								Please go to the All Devices page to check if your box is added or click on Check Errors on the Add
								Device Page.
							</p>
							<div class="button-container button-container-import-devices">
								<button
									class="primary-small-button"
									i18n="@@addDeviceConfirmation-returnToDevices"
									(click)="onGotoDevicesClicked()"
									data-automation-id="go-to-all-devices-button"
								>
									Return to Devices
								</button>
								<button
									(click)="onCheckErrorsClicked()"
									class="secondary-small-button"
									data-automation-id="check-errors-button"
									i18n="@@addDeviceConfirmation-checkErrors"
								>
									Check Errors
								</button>
							</div>
						</div>
					}
					<!-- Loading for transferring devices -->
					@if (isTransferringDevices && showLoading) {
						<div>
							<div>
								<mat-spinner diameter="25" style="float: left; margin-right: 20px"></mat-spinner>
								<ng-container i18n="@@addDeviceConfirmation-loadingText">
									Your request to transfer the devices is being processed. Please wait.
								</ng-container>
							</div>
						</div>
					}
					<!-- Confirmation for transferring devices -->
					@if (isTransferringDevices && !showLoading) {
						<div>
							<p i18n="@@addDeviceConfirmation-processedDeviceTranfers">We have processed all device transfers.</p>
							@if (!dataSource.data.length) {
								<p>
									<ng-container i18n="@@endBillingDialog-allDevicesHaveBeenTransferred"
										>All devices have been transferred to</ng-container
									>
									{{ transferToCompanyName }}.
								</p>
							}
							@if (dataSource.data.length) {
								<p>
									<ng-container i18n="@@endBillingDialog-allOtherDevicesHaveBeenTransferred"
										>Excluding the devices with errors below, all other valid devices have been transferred
										to</ng-container
									>
									{{ transferToCompanyName }}.
								</p>
							}
						</div>
					}
					<!-- Errors for device imports -->
					@if (serialNumberErrorList) {
						<div>
							<p i18n="@@addDeviceConfirmation-invalidSerialNumber">The following serial numbers were invalid.</p>
							@for (serialNumber of serialNumberErrorList; track serialNumber) {
								<mat-option [value]="serialNumber.serialNumber">
									{{ serialNumber.serialNumber }}
								</mat-option>
							}
						</div>
					}
				</div>
				<!-- Errors for device transfers -->
				@if (isTransferringDevices && !showLoading) {
					<div class="transferring-device-error-container">
						<h3><b i18n="@@addDeviceConfirmation-errors2">Errors</b></h3>
						<div class="content-container-body">
							<div>
								@if (dataSource.data.length) {
									<app-data-set #dataSet [dataSource]="dataSource" defaultPresentationMode="table">
										<app-data-set-content>
											<app-data-set-table-view>
												<table
													mat-table
													[dataSource]="dataSource"
													matSort
													matSortActive="deviceSerialNumber"
													matSortDirection="desc"
												>
													<tr class="mat-row" *matNoDataRow>
														<td
															class="mat-cell"
															[colSpan]="displayedColumns.length"
															i18n="@@dataSetTable-noRecordsFound"
														>
															No records found.
														</td>
													</tr>
													<ng-container matColumnDef="deviceSerialNumber">
														<th
															mat-header-cell
															*matHeaderCellDef
															mat-sort-header
															i18n="@@addDeviceMainTab-serialNumber"
														>
															Serial Number
														</th>
														<td mat-cell *matCellDef="let row">{{ row.deviceSerialNumber }}</td>
													</ng-container>
													<ng-container matColumnDef="deviceType">
														<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@addDeviceMainTab-deviceType">
															Device Type
														</th>
														<td mat-cell *matCellDef="let row">{{ row.deviceType }}</td>
													</ng-container>
													<ng-container matColumnDef="error">
														<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@addDeviceMainTab-error">
															Error
														</th>
														<td mat-cell *matCellDef="let row">
															{{ row.error === 'NotOwnedBySL' ? errorNotOwnedBySL : errorNotAssociatedWithAccess }}
														</td>
													</ng-container>
													<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
													<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
												</table>
											</app-data-set-table-view>
										</app-data-set-content>
									</app-data-set>
								}
							</div>
						</div>
					</div>
				}
				@if (isTransferringDevices && !showLoading) {
					<div class="button-container">
						<button
							class="primary-small-button"
							i18n="@@addDeviceConfirmation-returnToDevices"
							(click)="onGotoDevicesClicked()"
							data-automation-id="go-to-all-devices-button"
						>
							Return to Devices
						</button>
						<button
							(click)="onMoveAdditionalDevicesClicked()"
							class="secondary-small-button"
							data-automation-id="check-errors-button"
							i18n="@@addDeviceConfirmation-moreAdditionalDevices"
						>
							+ More Additional Devices
						</button>
					</div>
				}
			</div>
		}

		@if (showFailure) {
			<div class="content-container-body">
				<div>
					<p i18n="@@addDeviceConfirmation-failText">Your request to add the devices has failed. Please try again.</p>
					<div class="button-container button-container-import-devices">
						<button
							class="primary-small-button"
							i18n="@@addDeviceConfirmation-returnToDevices"
							(click)="onGotoDevicesClicked()"
							data-automation-id="go-to-all-devices-button"
						>
							Return to Devices
						</button>
						<button
							(click)="onMoveAdditionalDevicesClicked()"
							class="secondary-small-button"
							data-automation-id="retry-adding-devices-button"
							i18n="@@addDeviceConfirmation-retryAddingDevices"
						>
							Retry Adding Devices
						</button>
					</div>
				</div>
			</div>
		}
	</div>
</div>
